import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const EciRoutes: Routes = [
  {
    path: "eci",
    loadComponent: () =>
      import("./eci/eci.component").then((m) => m.EciComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./eci-list/eci-list.component").then(
            (m) => m.EciListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./eci-form/eci-form.component").then(
            (m) => m.EciFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./eci-form/eci-form.component").then(
            (m) => m.EciFormComponent,
          ),
      },
    ],
  },
];
